import React from 'react'
import { Badge, Box, Flex, SimpleGrid, Text } from '@chakra-ui/react'

import { formatUTCDate } from 'lib/date-time'
import { formatMoney } from 'lib/numbers'

type AddOn = {
  price: number
  liability_type_name: string
}

const SummaryItem = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Box>
    <Text color='gray.600' fontSize='sm'>
      {label}
    </Text>
    <Box fontWeight='semibold' mt={1}>
      {value}
    </Box>
  </Box>
)

const RenewRentalModalDetails = ({
  address,
  rent,
  optionPremium,
  leaseEndDate,
  addOns
}: {
  address: string
  rent: number
  optionPremium: number
  leaseEndDate: Date
  addOns: AddOn[]
}) => {
  const addOnSummary = [...addOns]
    .sort((left, right) => left.liability_type_name.localeCompare(right.liability_type_name))
    .map((addOn) => `${addOn.liability_type_name} (${formatMoney(addOn.price, 2, '$')}/month)`)
    .join(', ')

  return (
    <Box bg='gray.50' borderColor='gray.200' borderRadius='lg' borderWidth='1px' p={5}>
      <Flex align='center' gap={3} wrap='wrap' mb={4}>
        <Text fontSize='lg' fontWeight='semibold'>
          {address}
        </Text>
        <Badge colorScheme='blue'>Current lease</Badge>
      </Flex>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={5}>
        <SummaryItem
          label='Current monthly charges'
          value={
            <>
              {formatMoney(rent, 2, '$')} rent
              <Text color='gray.600' fontSize='sm' fontWeight='normal'>
                {formatMoney(optionPremium, 2, '$')} investment
              </Text>
            </>
          }
        />
        <SummaryItem
          label='Current lease ends'
          value={formatUTCDate(leaseEndDate, 'MMM d, yyyy')}
        />
        <SummaryItem
          label='Recurring add-ons'
          value={
            <Text fontSize='sm' fontWeight='medium'>
              {addOnSummary || 'None'}
            </Text>
          }
        />
      </SimpleGrid>
    </Box>
  )
}

export default RenewRentalModalDetails
